import React from 'react';

const lazyLoadSettings = {
    offset: 400,
    once: true,
    height: 0,
    imagePlaceholder: React.createElement('div', {
        className: 'animation-loading-shimmer w-100 h-100'
    })
};

export { lazyLoadSettings };
